document.addEventListener("DOMContentLoaded", function () {

    const bottomATC = document.querySelector('.bottom-atc');
    const addToCartBtn = document.querySelector('.addToCartBtn');

    if (!bottomATC || !addToCartBtn) return;

    let isATCVisible = true;
    
    // Track ATC visibility 
    const observer = new IntersectionObserver((entries) => {
        // If the main button (or bundle button) is intersecting, it's visible
        if (entries[0].isIntersecting) {
            isATCVisible = true;
            // Force hide immediately if the main button is on screen
            bottomATC.classList.add('hide');
            bottomATC.classList.remove('show');
        } else {
            isATCVisible = false;
        }
    }, {
        threshold: 0
    });

    observer.observe(addToCartBtn);

    // Scroll logic decides visibility
    window.addEventListener('scroll', () => {

        const atcRect = addToCartBtn.getBoundingClientRect();
        
        // Check if the bottom of the button has passed the top of the viewport
        const hasScrolledPastATC = atcRect.bottom < 0;

        if (hasScrolledPastATC && !isATCVisible) {
            bottomATC.classList.add('show');
            bottomATC.classList.remove('hide');
        } else {
            bottomATC.classList.add('hide');
            bottomATC.classList.remove('show');
        }
    });

    // Bundle button support
    setTimeout(() => {
        const bundlesButton = document.querySelector('.bogos-bundles-quantity-break-button-add');
        if (bundlesButton) {
            observer.observe(bundlesButton);
        }
    }, 1400);

    // Smooth scroll delegation
    const contentContainer = document.querySelector('.batc_content');

    if (contentContainer) {
        contentContainer.addEventListener('click', (event) => {
            const link = event.target.closest('a[href^="#"]');
            if (!link) return;

            const target = document.querySelector(link.getAttribute('href'));
            if (!target) return;

            event.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    }

});
